/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Status_PendingInputs */

const en_us2_body_assessment_status_pending = /** @type {(inputs: Body_Assessment_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working out your estimate…`)
};

const pt_br2_body_assessment_status_pending = /** @type {(inputs: Body_Assessment_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando a sua estimativa…`)
};

const es_419_body_assessment_status_pending = /** @type {(inputs: Body_Assessment_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando tu estimación…`)
};

const pt_pt2_body_assessment_status_pending = /** @type {(inputs: Body_Assessment_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A calcular a tua estimativa…`)
};

const fr_fr2_body_assessment_status_pending = /** @type {(inputs: Body_Assessment_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcul de ton estimation…`)
};

const de_de2_body_assessment_status_pending = /** @type {(inputs: Body_Assessment_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Schätzung wird berechnet…`)
};

const it_it2_body_assessment_status_pending = /** @type {(inputs: Body_Assessment_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolo della stima in corso…`)
};

/**
* | output |
* | --- |
* | "Working out your estimate…" |
*
* @param {Body_Assessment_Status_PendingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_status_pending = /** @type {((inputs?: Body_Assessment_Status_PendingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Status_PendingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_status_pending(inputs)
	if (locale === "es-419") return es_419_body_assessment_status_pending(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_status_pending(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_status_pending(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_status_pending(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_status_pending(inputs)
	return en_us2_body_assessment_status_pending(inputs)
});
export { body_assessment_status_pending as "body-assessment.status_pending" }